import { all } from "redux-saga/effects";

// Action types
import * as types from "../actionTypes/service-comments.types";

// Actions
import {
  getServiceCommentsSuccess,
  deleteCommentSuccess,
  createServiceCommentSuccess
} from "../actions/service-comments.actions";

// Calls
import {
  fetchServiceCommentsRequest,
  deleteCommentRequest,
  createServiceCommentRequest
} from "../../api/calls/service-comments.call";

import { fetchSaga } from "./fetch.saga";

export default function* servicesSaga() {
  yield all([
    fetchSaga({
      trigger: types.FETCH_SERVICE_COMMENTS_REQUEST,
      apiCall: fetchServiceCommentsRequest,
      args: a => [a.serviceId],
      onSuccess: r => getServiceCommentsSuccess(r.comments),
      failedType: types.FETCH_SERVICE_COMMENTS_FAILED
    })(),
    fetchSaga({
      trigger: types.DELETE_SERVICE_COMMENT_REQUEST,
      apiCall: deleteCommentRequest,
      args: a => [a.id],
      onSuccess: (r, a) => deleteCommentSuccess(r.message, a.id),
      failedType: types.DELETE_SERVICE_COMMENT_FAILED
    })(),
    fetchSaga({
      trigger: types.CREATE_SERVICE_COMMENT_REQUEST,
      apiCall: createServiceCommentRequest,
      args: a => [a.serviceId, a.serviceCommentFormValues],
      onSuccess: r => createServiceCommentSuccess(r.comment),
      failedType: types.CREATE_SERVICE_COMMENT_FAILED
    })()
  ]);
}
